import { RuleObject } from 'antd/lib/form';
import TranslateText from 'components/hoc/TranslateText';
import { phoneNumberRegExp } from 'enums/regExp';
import React from 'react';

export const phoneValidation = (rulesMessage: string) => [
    {
        required: true,
        message: <TranslateText>{rulesMessage}</TranslateText>
    },
    () => ({
        validator(_rule: RuleObject, value: string) {
            if (!value || phoneNumberRegExp.test(value)) return Promise.resolve();
            return Promise.reject(<TranslateText>NEVALIDNI_TELEFON</TranslateText>);
        }
    })
];

export default phoneValidation;

/*
export const phoneValidation = (rulesMessage: string) => [
    {
        required: true,
        message: <TranslateText>{rulesMessage}</TranslateText>,
    },
    () => ({
        validator(rule: RuleObject, value: string) {
            if (validator.isMobilePhone(value) == true && 
                value.startsWith('+') || value.startsWith('00') &&
                /\s/.test(value) == false &&
                value.length <= 17 && value.length >= 9) return Promise.resolve();
            return Promise.reject(
                <TranslateText>NEVALIDNI_TELEFON</TranslateText>
            );
        },
    }),
];

export default phoneValidation;
*/
